import React, { Fragment } from 'react';
import { AddressCell } from '../cells';
import { keysMap as columnKeysMap } from '../../constants/columns';
import { Table } from '../../../base/Table';

const ExpandedContent = ({ columns, room, withCheckbox }) => {
  const colOffset = withCheckbox ? 2 : 1;

  return room.relatedFlats.map((r, rIndex) => (
    <Fragment key={r.id}>
      {withCheckbox && (
        <Table.BodyCell column={1} row={rIndex + 2} type="empty-checkbox" />
      )}

      {columns.map(({ Cell, key }, colIndex) => {
        const column = colIndex + colOffset;
        const row = rIndex + 2;

        if (key === columnKeysMap.relation || key === columnKeysMap.date) {
          return null;
        }

        if (key === columnKeysMap.room && r.houseId !== room.houseId) {
          return <AddressCell key={key} column={column} row={row} record={r} />;
        }

        return <Cell key={key} record={r} column={column} row={row} />;
      })}
    </Fragment>
  ));
};

export default ExpandedContent;
